function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

class CartDiscount extends CustomElement {

  mounted() {
    super.mounted();

    this.cart = JSON.parse(this.dataset.cart);
    this.discountForm = this.querySelector('form.discount-form');
    this.applyButton = this.querySelector('.docapp-coupon-input--button');
    this.messageContainer = this.querySelector('.docapp-coupon-input--message-container');
    this.messageContent = this.querySelector('.docapp-coupon-input--message-content');
    this.appliedCodeContainer = this.querySelector('.docapp-coupon-input--bean-container');
    this.discountSummary = this.querySelector('.docapp-cart-with-coupon-summary--summary');
    this.settings = JSON.parse(this.dataset.sectionSettings);

    this.addEventListeners();

    this.initUTMCode();
    
  }

  #getRecentAppliedCodes() {
    return this.cart?.discount_codes || [];
  }

  get refs() {
    return {};
  }

  addEventListeners() {
    this.discountForm?.addEventListener('submit', this.applyDiscount.bind(this));
    this.appliedCodeContainer?.addEventListener('click', this.removeDiscount.bind(this));
    this.messageContainer?.addEventListener('click', this.clearMessage.bind(this));
  }

  clearMessage(event = null) {
    if (event && !event?.target?.classList.contains('docapp-coupon-input--message-x')) return;
    this.messageContainer?.classList.toggle('docapp-hide', true);
    this.messageContainer?.classList.toggle('docapp-alert-danger', false);
    this.messageContent.innerHTML = '';
  }

  refreshDiscounts(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const appliedCodes = doc.querySelector('.docapp-coupon-input--bean-container');
    const discountSummary = doc.querySelector('.docapp-cart-with-coupon-summary--summary');
    this.appliedCodeContainer.innerHTML = appliedCodes.innerHTML;
    this.discountSummary.innerHTML = discountSummary.innerHTML;
    this.cartDiscountUpdated();

  }

  fillDiscountCode(code) {
    const input = this.querySelector('input[name="temp-discount"]');
    if (input) {
      input.value = code;
    }
  }

  applyDiscount = async (event = null, code = null) => {

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const form = event ? event.target : this.querySelector('form');
    if (!(form instanceof HTMLFormElement)) return;

    const discountCode = form.querySelector('input[name="temp-discount"]');
    if (!(discountCode instanceof HTMLInputElement) || typeof this.dataset.sectionId !== 'string') return;

    const discountCodeValue = code || discountCode.value;

    try {
      const existingDiscounts = this.existingDiscounts();
      const alreadyApplied = existingDiscounts.some(
        c => c?.toLowerCase() === discountCodeValue?.toLowerCase()
      );
      // When called from UTM (code provided), always call API to re-sync with Shopify
      if (alreadyApplied && !code) return;

      this.clearMessage();

      this.applyButton.classList.toggle('docapp-active', true);

      // When applying from UTM, send only this code so we don't rely on possibly stale existingDiscounts
      const discountPayload = code != null
        ? discountCodeValue
        : [...existingDiscounts, discountCodeValue].join(',');

      const { data } = await cartService.update({
        discount: discountPayload,
        sections: [this.dataset.sectionId],
      });

      if (!data) return;

      this.cart = data;

      discountCode.value = '';

      this.refreshDiscounts(data.sections[this.dataset.sectionId]);

      const notApplicableDiscount = this.#getRecentAppliedCodes().find(discount => {
        return discount.code === discountCodeValue && discount.applicable === false;
      });
      if (notApplicableDiscount) {
        discountCode.value = '';
        if (this.cart?.item_count === 0) {
          this.#handleDiscountValidButEmptyCart();
        } else {
          this.#handleDiscountError('discount_code');
        }
        return;
      }

      const newHtml = data.sections[this.dataset.sectionId];
      const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      const section = parsedHtml.getElementById(`shopify-section-${this.dataset.sectionId}`);
      const codes = this.existingDiscounts();
      if (section) {
        // Before morphing, we need to check if the shipping discount is applicable in the UI
        // we check the liquid logic compared to the cart payload to assess whether we leveraged
        // a valid shipping discount code.
        if (
          codes.length === existingDiscounts.length &&
          codes.every(code => existingDiscounts.includes(code)) &&
          this.cart.discount_codes.find(discount => {
            return discount.code === discountCodeValue && discount.applicable === true;
          })
        ) {
          this.#handleDiscountError('shipping');
          discountCode.value = '';
          return false;
        } else {
          this.#handleDiscountSuccess('discount_code', discountCodeValue);
          return data;
        }
      }
      
    } catch (error) {
      console.log(error);
    } finally {
      this.applyButton.classList.toggle('docapp-active', false);
    }
  };

  removeDiscount = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.clearMessage();

    const discountCode = event.target?.getAttribute('data-code');

    if (!discountCode) return;

    const existingDiscounts = this.existingDiscounts();
    const index = existingDiscounts.indexOf(discountCode);
    if (index === -1) return;

    existingDiscounts.splice(index, 1);

    try {

      this.applyButton.classList.toggle('docapp-active', true);

      const { data } = await cartService.update({
        discount: existingDiscounts.join(','),
        sections: [this.dataset.sectionId],
      });

      this.cart = data;

      this.refreshDiscounts(data.sections[this.dataset.sectionId]);
    } catch (error) {
      console.log(error);
    } finally {
      this.applyButton.classList.toggle('docapp-active', false);
    }
  };


  #handleDiscountError(type) {
    if (type === 'discount_code') {
      this.messageContent.innerHTML = this.settings.code_failed_message;
    } else {
      this.messageContent.innerHTML = this.settings.shipping_code_failed_message;
    }
    this.messageContainer?.classList.toggle('docapp-hide', false);
    this.messageContainer?.classList.toggle('docapp-alert-danger', true);
    this.messageContainer?.classList.toggle('docapp-alert-success', false);
  }

  #handleDiscountValidButEmptyCart() {
    const message = this.settings.code_empty_cart_message || '商品をカートに追加いただくと、クーポンコードが反映されます。';
    this.messageContent.innerHTML = message;
    this.messageContainer?.classList.toggle('docapp-hide', false);
    this.messageContainer?.classList.toggle('docapp-alert-danger', false);
    this.messageContainer?.classList.toggle('docapp-alert-success', true);
  }

  #handleDiscountSuccess(type, discountCode) {
    if (type === 'discount_code') {
      const amount = this.#getDiscountAmount(discountCode);
      this.messageContent.innerHTML = this.settings.code_success_message
        .replace('{{code}}', discountCode)
        .replace('{{amount}}', currencyFormatter.format(amount / 100));
    } else {
      this.messageContent.innerHTML = this.settings.shipping_code_failed_message;
    }
    this.messageContainer?.classList.toggle('docapp-hide', false);
    this.messageContainer?.classList.toggle('docapp-alert-success', true);
    this.messageContainer?.classList.toggle('docapp-alert-danger', false);
  }

  #getDiscountAmount(code) {
    const discount = this.cart?.cart_level_discount_applications
      ?.filter(discount => discount?.discount_application?.type == 'discount_code' || discount?.type == 'discount_code')
      ?.find(discount => discount?.discount_application?.title === code || discount?.title === code);

    return discount ? discount?.total_allocated_amount || discount?.discount_application?.total_allocated_amount : null;
  }

  existingDiscounts() {
    const cartLevelDiscounts = this.cart?.cart_level_discount_applications
      ?.filter(discount => discount?.discount_application?.type == 'discount_code' || discount?.type == 'discount_code')
      ?.map(discount => discount?.discount_application?.title || discount?.title) || [];
    
    const discountedItems = this.cart?.items?.filter(item => item.line_level_discount_allocations.length > 0);

    let itemLevelDiscounts = [];
    
    discountedItems?.forEach(item => {
      itemLevelDiscounts = [
        ...itemLevelDiscounts, 
        ...item.line_level_discount_allocations
          ?.filter(discount => discount?.discount_application?.type == 'discount_code' || discount?.type == 'discount_code')
          ?.map(discount => discount?.discount_application?.title || discount?.title) || []
      ];
    });

    return [...new Set([...cartLevelDiscounts, ...itemLevelDiscounts])];
  }

  async cartDiscountUpdated() {
    const cart = this.cart;

    if (cart) {
      let availableCodes = JSON.parse(sessionStorage.getItem('availableCoupons') || '[]');
      const appliedCodes = this.existingDiscounts();
      if (appliedCodes.length) {
        appliedCodes.forEach(code => {
          if (!availableCodes.includes(code)) {
            availableCodes.push(code);
          }
        });
      }
      sessionStorage.setItem('availableCoupons', JSON.stringify(availableCodes));

      const savedCoupon = getCookie('coupon');
      const foundCode = appliedCodes.find(code => code?.toLowerCase() == savedCoupon?.toLowerCase());
      if (!foundCode && !!savedCoupon) {
        this.applyDiscount(null, savedCoupon);
      } else {
        setCookie('coupon', savedCoupon, -1);
      }
    }
  }

  async initUTMCode() {
    const url = new URL(window.location.href);
    const utmCodeRaw = url.searchParams.get('utm_code');
    const utmCodeNormalized = utmCodeRaw?.toLowerCase();
    const marketingCouponUrl = url.searchParams.get('coupon')?.toLowerCase();

    if (marketingCouponUrl) {
      sessionStorage.setItem('coupon', marketingCouponUrl);
    }

    if (!utmCodeRaw || !utmCodeNormalized) {
      return;
    }

    await ResourceCoordinator.requestVendor('Toastr');

    // Always sync UTM code to Shopify (send raw casing for API)
    await this.applyDiscount(null, utmCodeRaw);

    const codeInCart = this.cart?.discount_codes?.find(
      d => d?.code?.toLowerCase() === utmCodeNormalized
    );
    // Valid when: applicable, OR (not applicable but cart empty = valid code, will apply when items added).
    // Empty cart returns applicable: false for valid codes. Invalid codes usually get 422 and are not in discount_codes.
    const isValidCode = codeInCart && (
      codeInCart.applicable === true ||
      (codeInCart.applicable === false && this.cart?.item_count === 0)
    );

    if (!isValidCode) {
      toastr.error(this.settings.code_failed_message || 'ご入力いただいたクーポンコードが確認できません。');
      return;
    }

    if (this.cart?.item_count > 0) {
      toastr.success(`「${utmCodeRaw}」 割引コードが適用されました。`);
    } else {
      toastr.success(this.settings.code_empty_cart_message || '商品をカートに追加いただくと、クーポンコードが反映されます。');
    }

    // Sync with discount-on-cart-pro so it doesn't send removed_codes for this code on next request.
    // If the app is loaded we sync now; otherwise cart-drawer-lazyload will sync when the drawer opens.
    if (typeof window.discountOnCartProApp?.applyCode === 'function') {
      window.discountOnCartProApp.applyCode(utmCodeRaw);
    } else {
      window.__utmCodeToSyncWithDocapp = utmCodeRaw;
    }
  }

}

if (!customElements.get('cart-discount-component')) {
  customElements.define('cart-discount-component', CartDiscount);
}
